import {
    ROUTES_EQUIPMENT,
    ROUTES_EQUIPMENT_LIST,
    ROUTES_EQUIPMENT_LIST_FORM_CATEGORY,
    ROUTES_EQUIPMENT_LIST_FORM_EQUIPMENT,
    ROUTES_EQUIPMENT_LIST_ITEM_LOGS
} from '@/constants/routes';

export default {
    path: '/equipment-list',
    name: ROUTES_EQUIPMENT,
    component: () => import(/* webpackChunkName: 'equipment' */ '@/views/EquipmentList.vue'),
    redirect: { name: ROUTES_EQUIPMENT_LIST },
    children: [
        {
            path: '/equipment-list',
            name: ROUTES_EQUIPMENT_LIST,
            component: () => import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/Equipment.vue')
        },
        {
            path: 'form-category/:categoryId?',
            name: ROUTES_EQUIPMENT_LIST_FORM_CATEGORY,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentAddCategory.vue')
        },
        {
            path: 'form-equipment/:categoryId?/:equipmentId?',
            name: ROUTES_EQUIPMENT_LIST_FORM_EQUIPMENT,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentAddEquipment.vue')
        },
        {
            path: ':equipmentId?/logs',
            name: ROUTES_EQUIPMENT_LIST_ITEM_LOGS,
            component: () =>
                import(/* webpackChunkName: 'equipment' */ '@/components/equipment-list/EquipmentListItemLogs.vue')
        }
    ]
};